module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-reviews",
    style: ({
      backgroundImage: "url(" + _vm.content.testimonials.bg + ")"
    })
  }, [_c('div', {
    staticClass: "home-reviews__content"
  }, [_c('div', {
    staticClass: "home-reviews__title"
  }, [_vm._v(_vm._s(_vm.content.testimonials.mtitle))]), _c('div', {
    staticClass: "home-reviews__reviews"
  }, [_vm._l((_vm.content.testimonials.reviews), function(review) {
    return _c('div', {
      staticClass: "home-reviews__review"
    }, [_c('div', {
      staticClass: "home-reviews__reviewbox"
    }, [_c('div', {
      staticClass: "home-reviews__review-quote"
    }, [_c('div', {
      staticClass: "home-reviews__review-name"
    }, [_vm._m(0, true), _c('h4', {
      staticClass: "home-reviews__reviewboxtitle"
    }, [_vm._v(_vm._s(review.name))]), _c('p', {
      staticClass: "home-reviews__reviewbopara"
    }, [_vm._v(_vm._s(review.quote))])])]), _c('div', {
      staticClass: "home-reviews__review-arrow"
    })])])
  }), _c('div', {
    staticClass: "home-reviews__sosh"
  }, [_c('div', {
    staticClass: "home-reviews__sosh-icons"
  }, _vm._l((_vm.content.testimonials.solmed), function(solmed) {
    return _c('div', {
      staticClass: "home-reviews__soshitems"
    }, [_c('a', {
      staticClass: "home-reviews__sosh-icon",
      attrs: {
        "href": solmed.solurl,
        "target": "_blank",
        "title": "Social Media Open in new tab"
      }
    }, [_c('img', {
      staticClass: "reviewicon",
      attrs: {
        "src": solmed.solimg
      }
    })])])
  }), 0), _c('div', {
    staticClass: "home-reviews__sosh-cta"
  }, [_vm._v("share your experience!")])])], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-reviews__reviewboxstar"
  }, [_c('div', {
    staticClass: "home-reviews__reviewstaritem"
  }, [_c('img', {
    attrs: {
      "src": "https://www.opsmiles.com/wp-content/uploads/newstar.png",
      "alt": "newstar"
    }
  }), _c('img', {
    attrs: {
      "src": "https://www.opsmiles.com/wp-content/uploads/newstar.png",
      "alt": "newstar"
    }
  }), _c('img', {
    attrs: {
      "src": "https://www.opsmiles.com/wp-content/uploads/newstar.png",
      "alt": "newstar"
    }
  }), _c('img', {
    attrs: {
      "src": "https://www.opsmiles.com/wp-content/uploads/newstar.png",
      "alt": "newstar"
    }
  }), _c('img', {
    attrs: {
      "src": "https://www.opsmiles.com/wp-content/uploads/newstar.png",
      "alt": "newstar"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a3bd044","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-home-reviews/custom-home-reviews.pug
// module id = 648
// module chunks = 1